import {
  Box,
  Button,
  Container,
  Grid,
  Stack,
  Step,
  StepIconProps,
  StepLabel,
  Stepper,
  Typography,
} from '@mui/material';
import StepConnector, {
  stepConnectorClasses,
} from '@mui/material/StepConnector';
import { styled } from '@mui/material/styles';

import { gridSizeMdLg12, gridSizeMdLg9 } from '@/shared';

///* custom styles for stepper
const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#6366F1',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#6366F1',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor:
      theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const QontoStepIconRoot = styled('div')<{ ownerState: { active?: boolean } }>(
  ({ theme, ownerState }) => ({
    color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#eaeaf0',
    display: 'flex',
    height: 22,
    alignItems: 'center',
    ...(ownerState.active && {
      color: '#6366F1',
    }),
    '& .QontoStepIcon-completedIcon': {
      color: '#6366F1',
      zIndex: 1,
      fontSize: 18,
    },
    '& .QontoStepIcon-circle': {
      width: 8,
      height: 8,
      borderRadius: '50%',
      backgroundColor: '#6366F1',
    },
  })
);

function QontoStepIcon(props: Readonly<StepIconProps>) {
  const { active, className } = props;

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      <div className="QontoStepIcon-circle" />

    </QontoStepIconRoot>
  );
}

export type StepperBoxSceneProps = {
  steps: any[];
  activeStep: any;

  // btns
  onCancel: () => void;
  onReject?: () => void;
  onSave: (
    e?: React.BaseSyntheticEvent<object, any, any> | undefined
  ) => Promise<void>;
  customNameOnSave?: string;
  showSaveButton?: boolean;
  handleNext: () => void;
  handleBack: () => void;
  disableNextStepBtn: boolean;
  enableCustomOnlyTopRightButton?: boolean;
  enableCustomTopRightButton?: boolean;
  fragmentCustomTopRightButton?: React.ReactNode;
  nameCustomTopRightButton?: string;
  actionCustomTopRightButton?: () => void;
  //
  enableCustomBottomButton?: boolean,
  fragmentCustomBottomButtons?: React.ReactNode
  nameCustomBottomButton?: string
  actionCustomBottomButtons?: () => void

  titlePage: string;

  children: React.ReactNode;

  size?: {
    xs: number;
    sm: number;
    md: number;
    lg: number;
  };

  py?: number;
  num_referencia?: string;
  additionalNoteText?: React.ReactNode;
};

const StepperBoxScene: React.FC<StepperBoxSceneProps> = ({
  steps,
  activeStep,

  // actions btns
  onCancel,
  onReject,
  showSaveButton = true,
  onSave,
  customNameOnSave,
  handleNext,
  handleBack,
  disableNextStepBtn,
  enableCustomOnlyTopRightButton = false,
  enableCustomTopRightButton = false,
  fragmentCustomTopRightButton = false,
  nameCustomTopRightButton = "Guardar",
  fragmentCustomBottomButtons = false,



  actionCustomTopRightButton,

  titlePage,
  size = gridSizeMdLg9,

  children,
  py = 8,
  num_referencia,
  additionalNoteText
}) => {
  //const isMobile = useIsMediaQuery('sm');

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: py,
      }}
    >
      <Container maxWidth="lg">
        <Stack spacing={3}>
          {
            num_referencia
              ?
              <>
                <Typography variant="h4">
                  {`${titlePage} `}
                  <span className="cliente__page--subtitle">
                    (#{num_referencia})
                  </span>
                </Typography>
              </>
              :
              <Typography variant="h4" pb={3}>{titlePage}</Typography>
          }
          {
            additionalNoteText ?
              <Grid item {...gridSizeMdLg12}>
                {additionalNoteText}
              </Grid>
              : null
          }
          {
            enableCustomOnlyTopRightButton ?
              <Grid container direction={"row-reverse"}>
                <Button variant="outlined" onClick={actionCustomTopRightButton}>
                  {nameCustomTopRightButton}
                </Button>
              </Grid>
              : null
          }
          {
            enableCustomTopRightButton ?
              <Grid container direction={"row-reverse"} gap={1}>
                {fragmentCustomTopRightButton}
              </Grid>
              : null
          }


          {/* ================ main conent ================ */}
          <Grid container justifyContent="center" alignItems="center">
            <Grid item {...size}>
              {/* ============ stepper labels ============ */}
              <Stepper
                activeStep={activeStep}
                sx={{ mb: '38px', overflowX: 'auto' }}
                connector={<QontoConnector />}
              >
                {steps.map((label, _index) => {
                  // labels
                  return (
                    <Step key={label}>
                      {/* label for linear */}
                      <StepLabel StepIconComponent={QontoStepIcon}>
                        {label}
                      </StepLabel>
                    </Step>
                  );
                })}
              </Stepper>

              {/* ============ stepper conentent & handlers ============ */}
              {/* ======= actual content ======= */}
              {children}

              {/* ======= handler btns ======= */}
              <Box sx={{ display: 'flex', flexDirection:{xs:'column',md:'row'} , pt: 3, gap:1 }}>


                <Button
                  onClick={onCancel}
                  sx={{
                    color: '#4D5761',
                  }}
                >
                  Cancelar
                </Button>

                {
                  onReject && (
                    <Button
                      variant='outlined'
                      onClick={onReject}
                      color='error'

                    >
                      Rechazar
                    </Button>)
                }

                <span className="spacer"></span>


                <Button
                  color="inherit"
                  onClick={handleBack}
                  sx={{ mr: 1 }}
                  disabled={activeStep === 0}
                >
                  Atrás
                </Button>

                {activeStep !== steps.length - 1 && (
                  <Button onClick={handleNext} disabled={disableNextStepBtn}>
                    Siguiente
                  </Button>
                )}
                {fragmentCustomBottomButtons && (
                  <Stack direction={{xs:'column', md:'row-reverse'}} spacing={1} mr={2} width={{xs:'100%', md:'auto'}}>
                    {fragmentCustomBottomButtons}
                  </Stack>
                )}
                {activeStep === steps.length - 1 && showSaveButton && (
                  <Button onClick={onSave} variant="contained">
                    {customNameOnSave || "Guardar"}
                  </Button>
                )}
              </Box>
            </Grid>
          </Grid>
        </Stack>
      </Container>
    </Box>
  );
};

export default StepperBoxScene;
